import Vue from 'vue'
import VueRouter from 'vue-router'
import {route} from "vant/lib/utils/router";

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'CusDocList',
    redirect: '/CusDocList'
  },
  {
    path: '/CusDocList',
    name: 'CusDocList',
    meta: {
      index: 1,
      title:"名医堂"
    },
    component: () => import(/* webpackChunkName: "home" */ 'views/Customer/CusDocList.vue'),
  },
  {
    path: '/CusDocDetail',
    name: 'CusDocDetail',
    meta: {
      index: 2,
      title:"医生介绍"
    },
    component: () => import(/* webpackChunkName: "home" */ 'views/Customer/CusDocDetail.vue'),
  },
  {
    path: '/CusDocSch',
    name: 'CusDocSch',
    meta: {
      index: 3,
      title:"排班信息"
    },
    component: () => import(/* webpackChunkName: "home" */ 'views/Customer/CusDocSch.vue'),
  },
  {
    path: '/CusDocBook',
    name: 'CusDocBook',
    meta: {
      index: 4,
      title:"预约就诊"
    },
    component: () => import(/* webpackChunkName: "home" */ 'views/Customer/CusDocBook.vue'),
  },
  {
    path: '/CusInfo',
    name: 'CusInfo',
    meta: {
      index: 5,
      title:"我的信息"
    },
    component: () => import(/* webpackChunkName: "home" */ 'views/Customer/CusInfo.vue'),
  },
  {
    path: '/CusAddress',
    name: 'CusAddress',
    meta: {
      index: 6,
      title:"就诊人地址"
    },
    component: () => import(/* webpackChunkName: "home" */ 'views/Customer/CusAddress.vue'),
  },
  {
    path: '/CusMyDoc',
    name: 'CusMyDoc',
    meta: {
      index: 7,
      title:"我的医生"
    },
    component: () => import(/* webpackChunkName: "home" */ 'views/Customer/CusMyDoc.vue'),
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to,from, next)=>{
  if (to.meta.title){
    document.title= to.meta.title;
  }
  next()
});

export default router
